// extracted by mini-css-extract-plugin
export var boldText = "_5p-4";
export var checkboxContainer = "_5p-6";
export var closeIcon = "_5p-i";
export var container = "_5p-0";
export var drawer = "_5p-8";
export var drawerContent = "_5p-9";
export var extraSmallText = "_5p-5";
export var fulfillmentGroupTable = "_5p-e";
export var largeText = "_5p-3";
export var loadingSpinnerContainer = "_5p-j";
export var mediumText = "_5p-2";
export var narrow = "_5p-f";
export var notificationLink = "_5p-l";
export var packageCheckIconContainer = "_5p-7";
export var slideoutHeaderActions = "_5p-g";
export var slideoutHeaderActionsShifted = "_5p-h";
export var slideoutHeaderContainer = "_5p-a";
export var slideoutModal = "_5p-c";
export var stickyHeaderWrapper = "_5p-b";
export var table = "_5p-k";
export var tableContainer = "_5p-d";
export var tertiaryText = "_5p-1";